export const getPostAuthPath = (userStatus) => {
  if (userStatus === "certified") {
    return "/dashboard";
  }
  return "/onboarding";
};

export const loginFromResponse = (AuthCtx, data, navigate) => {
  const { token, user } = data;
  AuthCtx.login(
    token,
    user.userRole,
    user.userStatus,
    user.tokens,
    user.usedTokens,
    user.user_info,
    { id: user._id, email: user.email }
  );
  navigate(getPostAuthPath(user.userStatus), { replace: true });
};
